module.exports = __webpack_public_path__ + "img/built_in.3d1d5ece.svg";